(() => {
  const page = window.location.pathname.split('/').filter(Boolean).pop();
  const formPages = ['contact-us', 'become-a-dealer', 'damage-warranty-claims'];
  const main = document.getElementById('MainContent');
  if (!main) return;
  const pageTitle = main.querySelector('h1')?.textContent.trim();

  function repairContent() {
    if (page === 'contact-us') {
      main.querySelectorAll('.rte h1').forEach((heading) => {
        const replacement = document.createElement('h2');
        replacement.className = heading.className;
        replacement.append(...heading.childNodes);
        heading.replaceWith(replacement);
      });
    }
    if (page === 'faqs') {
      main.querySelectorAll('.rte p').forEach((paragraph) => {
        if (paragraph.children.length !== 1 || paragraph.firstElementChild.tagName !== 'STRONG') return;
        if (!paragraph.textContent.trim().endsWith('?')) return;
        const heading = document.createElement('h2');
        heading.className = 'h3';
        heading.textContent = paragraph.textContent;
        paragraph.replaceWith(heading);
      });
      main.querySelectorAll('a').forEach((link) => {
        if (link.textContent.trim() === 'B' && link.getAttribute('href') === 'http://alpinefurniture.net/become-a-dealer') {
          const paragraph = link.closest('p');
          const remainder = paragraph && Array.from(paragraph.querySelectorAll('a')).find((item) => item.textContent.trim() === 'ECOME A DEALER');
          if (remainder) {
            remainder.textContent = 'BECOME A DEALER';
            remainder.href = '/pages/become-a-dealer';
            link.remove();
          }
        }
        if (link.getAttribute('href') === 'http://alpinefurniture.net/california-proposition-65') {
          if (link.textContent.trim()) link.href = '/pages/california-prop-65-warning';
          else link.remove();
        }
      });
    }
  }

  function repairFrame(frame) {
    if (page === 'digital-catalog' && frame.getAttribute('src') === 'https://alpine-flipbooks.alpinefurniture.workers.dev/') {
      frame.title = pageTitle;
    }
    if (!formPages.includes(page) || !frame.classList.contains('hs-form-iframe')) return;
    frame.title = pageTitle;
    try {
      const formDocument = frame.contentDocument;
      if (!formDocument || !formDocument.head || formDocument.getElementById('alpine-form-accessibility')) return;
      const style = formDocument.createElement('style');
      style.id = 'alpine-form-accessibility';
      style.textContent = '.hs-button.primary, input[type="submit"] { background: #800020 !important; border-color: #800020 !important; color: #fff !important; min-height: 44px; } .hs-button.primary:focus-visible, input[type="submit"]:focus-visible { outline: 3px solid #121212 !important; outline-offset: 3px; }';
      formDocument.head.append(style);
    } catch (error) {
      console.warn('The embedded form requires its provider to apply accessibility styling.');
    }
  }

  repairContent();
  main.querySelectorAll('iframe').forEach(repairFrame);
  main.addEventListener('load', (event) => {
    if (event.target instanceof HTMLIFrameElement) repairFrame(event.target);
  }, true);
  if (formPages.includes(page) || page === 'digital-catalog') {
    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node instanceof HTMLIFrameElement) repairFrame(node);
          node.querySelectorAll('iframe').forEach(repairFrame);
        }
      }
    }).observe(main, { childList: true, subtree: true });
  }
})();
